module.exports = __webpack_public_path__ + "media/profile/subscription-icon-b83315e9.svg";